import { useState } from "react";
import styles from "./Product.module.css";
import { Link } from "react-router-dom";

export default function FirstNews({ news }) {
  const [index, setIndex] = useState(0);
  const handleNext = () => {
    const tmpIndex = index + 1;
    setIndex(tmpIndex % news.attachment_files.length);
  };
  const handlePrev = () => {
    const tmpIndex = index - 1;
    setIndex(tmpIndex < 0 ? news.attachment_files.length - 1 : tmpIndex);
  };
  return news ? (
    <>
      <div className={styles.mainNewsContent}>
        <div className={styles.mainNewsImage}>
          <div className={styles.arrowsForChange}>
            <div onClick={handlePrev}>
              <i className="fa fa-arrow-right" />
            </div>
            <div onClick={handleNext}>
              <i className="fa fa-arrow-left" />
            </div>
          </div>
          <img
            className={
              Array.isArray(news.attachment_files) &&
              news.attachment_files.length > 0
                ? ""
                : styles.grayScaleOne
            }
            src={
              Array.isArray(news.attachment_files) &&
              news.attachment_files.length > 0
                ? news.attachment_files[index].server_relative_url
                : "/assets/image/logo.png"
            }
            alt={news.title}
          />
        </div>
        <div
          className={`${styles.productContentItem} ${styles.productContentItemSingle}`}
        >
          <div className={styles.productBarContentSmallInfo}>
            <i className={"fa fa-calendar calendar-set-item"}></i> تاریخ انتشار
            : {news.publish_date}
          </div>
          <div className={styles.productBarContent}>{news.title}</div>
          <div className={styles.productBarContentDate}>
            {news.short_description}
          </div>
          <Link
            to={
              window.location.href.indexOf("/retired") >= 0
                ? "/retired/news/show/" + news?.guid
                : window.location.href.indexOf("/partners") >= 0
                ? "/partners/news/show/" + news?.guid
                : window.location.href.indexOf("/vsat") >= 0
                ? "/vsat/news/show/" + news?.guid
                : "/news/show/" + news?.guid
            }
            className={styles.textDecorationNone}
          >
            <div className={styles.productBarMoreStudyFirst}>
              ادامه خبر <i className="fa fa-angle-left"></i>
            </div>
          </Link>
        </div>
      </div>
    </>
  ) : (
    <div className="loading-wrapper">
      <img src={"../../../assets/image/loading.svg"} alt={"در حال بار گذاری"} />
    </div>
  );
}
